import { baseApiForNurse } from "./baseApi";

export const trainingApi = baseApiForNurse.injectEndpoints({
    credentials: "include",
    endpoints: (builder) => ({
        getTrainingByCategoryId: builder.query({
            query: (id) => {
                return {
                    url: "/training?training_category_id=" + id,
                    method: "GET",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                };
            },
            refetchOnFocus: true,
        }),
        enrollTraining: builder.mutation({
            query: (data) => {
              return {
                url: "training-enrollment",
                method: "POST",
                body: data,
                headers: {
                  "Content-type": "application/json; charset=UTF-8",
                },
              };
            },
            keepUnusedDataFor: 0,
            refetchOnFocus: true,
          }),
    }),
});

export const {
    useGetTrainingByCategoryIdQuery,
    useEnrollTrainingMutation,
} = trainingApi;
